import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AuthenticationFactorListItem
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList/Content/AuthenticationFactorListItem';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import BasicAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';

const styles = (theme) => ({
  root: {},
  alert: {
    marginTop: theme.spacing(2),
  },
});
/**
 * @deprecated use AuthenticationFactorList from ComponentLibrary/Organisms/AuthenticationFactorList
 */
const AuthenticationFactorList = ({
  className,
  classes,
  collection,
}) => {
  const numberEnabled = collection?.resources?.()?.list()?.filter((authenticationFactorResource) => authenticationFactorResource.attr('enabled') === 'true')?.length ?? 0;

  return (
    <List
      className={classNames(classes.root, className)}
    >
      {numberEnabled < 2 ? (
        <BasicAlert
          className={classes.alert}
          title={'Only one form of authentication enabled'}
          message={'We recommend enabling multiple forms of authentication for the most secure experience.'}
        />
      ) : null}
      {collection?.resources?.()?.list()?.map((authenticationFactorResource) => (
        <AuthenticationFactorListItem key={authenticationFactorResource.attr('authenticationType')} authenticationFactorResource={authenticationFactorResource} />
      ))}
    </List>
  );
};

AuthenticationFactorList.defaultProps = {
  className: '',
};

AuthenticationFactorList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorList);
